if (!customElements.get('component-collection-hero-slider')) {

    class CollectionHeroSlider extends HTMLElement {
        constructor() {
            super();

            this.selectors = {
                slider: "swiper-container",
                prevEl: ".custom-prev-button",
                nextEl: ".custom-next-button",
                arrow: "[data-slider-arrow]",
                cardImageWrapper: "[data-card-image-wrapper]"
            }

            this.modifiers = {
                initialized: "initialized"
            };
        }

        connectedCallback() {
            this.slider =
                this.querySelector(this.selectors.slider);
            this.buttonPrev =
                this.querySelector(this.selectors.prevEl);
            this.buttonNext =
                this.querySelector(this.selectors.nextEl);
            this.cardImageWrapper =
                this.querySelector(this.selectors.cardImageWrapper) ?? null;


            if (!this.slider) {
                return null;
            }

            this.initSlider()
            this.addListeners();
        }

        initSlider() {

            this.swiperParams = {
                slidesPerView: 2.5,
                spaceBetween: 16,
                breakpoints: {
                    320: {
                        slidesPerView: 2.60,
                    },
                    500: {
                        slidesPerView: 3,
                    },
                    660: {
                        slidesPerView: 3.5,
                    },
                    800: {
                        slidesPerView: 4,
                    },
                    900: {
                        slidesPerView: 4.5,
                    },
                    990: {
                        slidesPerView: 5,
                    },
                    1200: {
                        slidesPerView: 6.36,
                    },
                    1920: {
                        slidesPerView: 7,
                    }
                },
                navigation: {
                    nextEl: this.buttonNext,
                    prevEl: this.buttonPrev
                },
                on: {
                    afterInit: () => {
                        this.setArrowsVerticalPosition();
                        this.classList.add(this.modifiers.initialized);
                    },
                    beforeResize: () => {
                        this.setArrowsVerticalPosition();
                    },
                    update: () => {
                        this.setArrowsVerticalPosition();
                    }
                },
            };

            Object.assign(this.slider, this.swiperParams);

            this.slider.initialize();
        }

        setArrowsVerticalPosition() {
            if (!this.swiperParams.navigation || !this.cardImageWrapper) {
                return null;
            }

            const arrows = this.querySelectorAll(this.selectors.arrow);

            if (!arrows) {
                return null;
            }

            const position = `${this.cardImageWrapper.offsetHeight / 2}px`;

            arrows.forEach((arrow) => {
                arrow.style.top = position;
            });
        }

        addListeners() {
            document.addEventListener('shopify:section:reorder', () => this.initSlider());
        }
    }

    customElements.define('component-collection-hero-slider', CollectionHeroSlider);

}
